import EditableQuantityCell from '../../../../shared/EditableQuantityCell';

export const buildTransferProductColumns = (
  onQuantityChange: (detailId: number, quantity: number) => void
) => [
  {
    accessor: 'productName',
    label: 'Producto',
  },
  {
    accessor: 'quantity',
    label: 'Cantidad',
    render: (_: any, row: any) => (
      <EditableQuantityCell
        value={Number(row.quantity)}
        unitCode={row.unitCode}
        onCommit={(qty) => onQuantityChange(row.id, qty)}
      />
    ),
  },
];
